const ITEMS = [
    "Where did my money go?",
    "Ask fynary — spending assistant",
    "CSV import · HDFC, SBI, ICICI, Axis, Kotak",
    "No passwords, PINs or OTPs",
    "Monthly snapshot",
    "Manual transaction entry",
    "Six-month trends",
    "Private to you",
];

export default function Marquee() {
    return (
        <div className="marquee overflow-hidden border-y border-white/5 bg-[#131315] py-4" data-testid="marquee-band">
            <div className="marquee-track flex w-max">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
                        {ITEMS.map((item) => (
                            <span key={item} className="flex items-center">
                                <span className="whitespace-nowrap px-8 text-xs font-semibold uppercase tracking-[0.22em] text-fynary-muted sm:text-sm">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rounded-full bg-fynary-lime/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
